import H4 from '@base/H4/H4';
import H5 from '@base/H5/H5';
import H6 from '@base/H6/H6';
import H7 from '@base/H7/H7';
import Image from '@base/Image';
import styled from '@emotion/styled';
import { Spacings, Fonts, mediaQuery } from '@styles/index';

const GTPEducatorsWrapper = styled.div`
  position: relative;
  grid-column: span 18;
  margin-top: -${Spacings.SPACING_5B};
`;

const Card = styled.div`
  width: calc(50% - ${Spacings.SPACING_2B});
  padding: ${Spacings.SPACING_4B};
  background: var(--color-base-1);
  border-radius: ${Spacings.SPACING_2B};
  display: flex;
  margin-bottom: ${Spacings.SPACING_4B};
  ${mediaQuery.uptoMobile} {
    width: 100%;
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  height: 80px;
  width: 80px;
`;

const EducatorDetails = styled.div`
  width: calc(100% - 106px);
  margin-left: ${Spacings.SPACING_4B};
  display: flex;
  flex-direction: column;
  align-items: space-between;
`;

const Title = styled(H5)`
  line-height: ${Fonts.PARA_LINE_HEIGHT};
  margin-bottom: ${Spacings.SPACING_2B};
  font-weight: ${Fonts.SEMIBOLD};
`;

const EducatorSubtitle = styled(H6)`
  line-height: ${Fonts.PARA_LINE_HEIGHT};
  font-size: ${Fonts.EXTRA_SMALL};
  margin-bottom: ${Spacings.SPACING_3B};
  font-weight: ${Fonts.HEAVY};
`;

const EducatorDescription = styled(H7)`
  line-height: ${Fonts.HEADER_LINE_HEIGHT};
  color: var(--color-text-primary);
  margin-bottom: ${Spacings.SPACING_4B};
  font-weight: ${Fonts.LIGHT};
`;

const EducatorExperienceTag = styled(H7)`
  line-height: ${Fonts.HEADER_LINE_HEIGHT};
  font-weight: ${Fonts.SEMIBOLD};
  color: var(--color-text-secondary);
  margin-top: auto;
`;

const EducatorCardsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: ${Spacings.SPACING_8B};
`;

const StyH4 = styled(H4)`
  text-transform: capitalize;
  color: var(--color-text-primary);
`;

const EducatorCard = ({ educator, width }) => {
  const { name, subject, subjectColor, description, footerText, image } =
    educator;
  return (
    <Card $width={width}>
      <ImageWrapper>
        <Image src={image} alt="educator" layout="fill" />
      </ImageWrapper>
      <EducatorDetails>
        <>
          <Title>{name}</Title>
          <EducatorSubtitle color={subjectColor}>{subject}</EducatorSubtitle>
          <EducatorDescription>{description}</EducatorDescription>
        </>
        <EducatorExperienceTag>{footerText}</EducatorExperienceTag>
      </EducatorDetails>
    </Card>
  );
};

const GTPEducatorBlock = ({ educators }) => {
  return (
    <GTPEducatorsWrapper>
      <StyH4>Educators</StyH4>
      <EducatorCardsWrapper>
        {educators.map((educator) => (
          <EducatorCard educator={educator} key={educator.id} />
        ))}
      </EducatorCardsWrapper>
    </GTPEducatorsWrapper>
  );
};

export default GTPEducatorBlock;
